import { createContext, useContext } from "react";

export type PremiumWorkspaceListMetaApi = {
  setListTotalCount: (n: number) => void;
};

export const PremiumWorkspaceListMetaContext = createContext<PremiumWorkspaceListMetaApi | null>(null);

export function usePremiumWorkspaceListMeta(): PremiumWorkspaceListMetaApi {
  const v = useContext(PremiumWorkspaceListMetaContext);
  if (!v) {
    throw new Error("usePremiumWorkspaceListMeta must be used under PremiumWorkspaceLayout");
  }
  return v;
}
